import React, { useEffect, useState } from "react";
import "./Dashboard.scss";
import DashboardHeader from "./DashboardHeader/DashboardHeader";
import DashboardQuickServices from "./DashboardQuickServices/DashboardQuickServices";
import DashboardYourServices from "./DashboardYourServices/DashboardYourServices";
import Hero from "../common/Hero/Hero";
import {Redirect} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import { useTranslation } from "react-i18next";
import DashboardAdminHeader from "./DashboardHeader/DashboardAdminHeader";
import DashboardNewContract from "./DashboardNewContract/DashboardNewContract";
import UserNotifications from "../common/UserNotifications/UserNotifications";
import { UserRoleEnum } from "../../helpers/enums";
import DashboardManagerHeader from "./DashboardManagerHeader/DashboardManagerHeader";
import DashboardCommonSection from "./DashboardCommonSection/DashboardCommonSection";
import { SwitchUser } from "../../helpers/helpers";
import ImageUploader from "../common/ImageUploader/imageUploader";
import SuccessModal from "../forms/ContractAddForm/Modal/index";
import DashboardSummary from "./DashboardSummary/DashboardSummary";
import ListCasePage from "../../components/pages/ListCasePage/ListCasePage";
import DashboardImpersonationSearch from "./DashboardImpersonation/DashboardImpersonationSearch/DashboardImpersonationSearch";
import {reloadContracts} from "../../reducers/contracts";
import Configuration from "../../config";
import Modal from "../common/Modal/Modal";

const Dashboard = () => {
  const { t, i18n } = useTranslation();
  const [changeImagePopup, setPopup] = useState(false);
  const user = useSelector((state) => state.auth);
  const userProfile = SwitchUser(user);
  const toBeReloadContract = useSelector((state) => state.contracts.reloadContract);
  const contracts = useSelector((state) => state.contracts.list);
  const [bill] = useSelector((state) => state.contracts.bills);
  const [usage] = useSelector((state) => state.contracts.usages);
  const metre = useSelector((state) => state.contracts.metre);
  const [showPopup, setShowPopup] = useState(true);
  const dispatch = useDispatch();
  const notifications = null;
  const activeContractDomiciliation = useSelector((state) => state.contracts?.serviceBankDomiciliation?.enabled);
  const quickServices = [
    {
      title: t("dashboard.service.quick.ticket.title"),
      description: t("dashboard.service.quick.ticket.description"),
      linkTo: "/online-bills",
      linkText: t("dashboard.service.quick.ticket.link"),
      icon: "icon-service-bollettaonline",
    },
    {
      title: t("dashboard.service.quick.selfreading.title"),
      description: t("dashboard.service.quick.selfreading.description"),
      linkTo: "/selfread-add",
      linkText: t("dashboard.service.quick.selfreading.link"),
      icon: "icon-verifica-metrica",
    },
    {
      title: t("dashboard.service.quick.pay.title"),
      description: t("dashboard.service.quick.pay.description"),
      linkTo: "/payment",
      linkText: t("dashboard.service.quick.pay.link"),
      icon: "icon-card-online",
    },
  ];
  const quickServicesAdmin = [
    {
      title: t("dashboard.service.admin.protection.title"),
      description: t("dashboard.service.admin.protection.description"),
      linkTo: "/tutela",
      linkText: t("dashboard.service.admin.protection.btn"),
      icon: "icon-service-water",
    },
    {
      title: t("dashboard.service.admin.bankdomiciliation.title"),
      description: t("dashboard.service.admin.bankdomiciliation.description"),
      linkTo: "/domiciliazione-bancaria",
      linkText: t("dashboard.service.admin.bill.btn"),
      icon: "icon-service-domiciliazionebancaria",
    },
    {
      title: t("dashboard.service.admin.bill.title"),
      description: t("dashboard.service.admin.bill.description"),
      linkTo: "/online-bills",
      linkText: t("dashboard.service.admin.bill.btn"),
      icon: "icon-service-bollettaonline",
    },
  ];
  const yourServices = [
    {
      tab: "la-tua-fornitura",
      tabName: t("dashboard.tab1.service"),
      services: [
        {
          title: t("dashboard.tab1.service.view.bills"),
          description: t("dashboard.tab1.service.view.bills"),
          link: "/bills",
          icon: "gc-icon-service-bolletta-1-col",
        },
        {
          title: t("dashboard.tab1.service.view.usages"),
          description: t("dashboard.tab1.service.view.usages"),
          link: "/usages",
          icon: "gc-icon-service-safety-1-col",
        },
        {
          title: t("dashboard.tab1.service.view.contracts"),
          description: t("dashboard.tab1.service.view.contracts"),
          link: "/contracts",
          icon: "gc-icon-functional-agreement-1-col",
        },
      ],
    },
    {
      tab: "servizi-online",
      tabName: t("dashboard.tab2.service"),
      services: [
        {
          title: t("dashboard.tab2.service.contract.title"),
          description: t("dashboard.tab2.service.contract.description"),
          link: "contracts/add",
          icon: "gc-icon-functional-agreement-1-col",
        },
        {
          title: t("dashboard.tab2.service.dissociatecontract.title"),
          description: t(
            "dashboard.tab2.service.dissociatecontract.description"
          ),
          link: "/contracts/dissociate",
          icon: "gc-icon-functional-agreement-1-col",
        },
        {
          title: t("dashboard.tab2.service.createfile.title"),
          description: t("dashboard.tab2.service.createfile.description"),
          link: "/view-cases",
          icon: "gc-icon-functional-tools-1-col",
        },
        {
          title: t("dashboard.tab2.service.tutela_perdite.title"),
          description: "",
          link: "/tutela",
          icon: "gc-icon-functional-tools-1-col",
        },
        {
          title: t("listCasePage.case.li.voltura"),
          description: "",
          link: "/voltura",
          icon: "gc-icon-functional-tools-1-col",
        },
        {
          title: t("listCasePage.case.li.allacciamento_acqua"),
          description: "",
          link: "/allacciamento",
          icon: "gc-icon-functional-tools-1-col",
        },
        {
          title: t("listCasePage.case.li.modifica_dati"),
          description: "",
          link: "/modifica-dati",
          icon: "gc-icon-functional-tools-1-col",
        },
      ],
    },
  ];
  const yourServicesAdmin = [
    {
      tab: "la-tua-fornitura",
      tabName: t("dashboard.tab1.service"),
      services: [
        {
          title: t("dashboard.tab1.service.view.bills"),
          description: t("dashboard.tab1.service.view.bills"),
          link: "/bills",
          icon: "gc-icon-service-bolletta-1-col",
        },
        {
          title: t("dashboard.tab1.service.view.usages"),
          description: t("dashboard.tab1.service.view.usages"),
          link: "/usages",
          icon: "gc-icon-service-safety-1-col",
        },
        {
          title: t("dashboard.tab1.service.view.contracts"),
          description: t("dashboard.tab1.service.view.contracts"),
          link: "/contracts",
          icon: "gc-icon-functional-agreement-1-col",
        },
      ],
    },
    {
      tab: "servizi-online",
      tabName: t("dashboard.tab2.service"),
      services: [
        {
          title: t("dashboard.tab2.service.payment.creditCard.title"),
          description: "",
          link: "/payment",
          icon: "gc-icon-functional-agreement-1-col",
        },
        {
          title: t("dashboard.tab2.service.selfread.title"),
          description: "",
          link: "/selfread-add",
          icon: "gc-icon-functional-agreement-1-col",
        },
        {
          title: t("dashboard.tab2.service.contract.title"),
          description: t("dashboard.tab2.service.contract.description"),
          link: "contracts/add",
          icon: "gc-icon-functional-agreement-1-col",
        },
        {
          title: t("dashboard.tab2.service.createfile.title"),
          description: t("dashboard.tab2.service.createfile.description"),
          link: "/view-cases",
          icon: "gc-icon-functional-tools-1-col",
        },
        {
          title: t("listCasePage.case.li.rateizzazione_bolletta"),
          description: "",
          link: "/rateizzazione-bolletta",
          icon: "gc-icon-functional-tools-1-col",
        },
        {
          title: t("listCasePage.case.li.rettifica_fatturazione"),
          description: "",
          link: "/rettifica-fatturazione",
          icon: "gc-icon-functional-tools-1-col",
        },
        {
          title: t("listCasePage.case.li.modifica_dati"),
          description: "",
          link: "/modifica-dati",
          icon: "gc-icon-functional-tools-1-col",
        },
      ],
    },
  ];
  const yourServicesCommunal = [
    {
      tab: "la-tua-fornitura",
      tabName: t("dashboard.tab1.service"),
      services: [
        {
          title: t("dashboard.tab1.service.view.bills"),
          description: t("dashboard.tab1.service.view.bills"),
          link: "/bills",
          icon: "gc-icon-service-bolletta-1-col",
        },
        {
          title: t("dashboard.tab1.service.view.usages"),
          description: t("dashboard.tab1.service.view.usages"),
          link: "/usages",
          icon: "gc-icon-service-safety-1-col",
        },
        {
          title: t("dashboard.tab1.service.view.contracts"),
          description: t("dashboard.tab1.service.view.contracts"),
          link: "/contracts",
          icon: "gc-icon-functional-agreement-1-col",
        },
      ],
    },
    {
      tab: "servizi-online",
      tabName: t("dashboard.tab2.service"),
      services: [
        {
          title: t("dashboard.tab2.service.ticket.title"),
          description: t("dashboard.tab2.service.ticket.description"),
          link: "/online-bills",
          icon: "gc-icon-service-bolletta-online-1-col",
        },
        {
          title: t("dashboard.tab2.service.selfreading.title"),
          description: t("dashboard.tab2.service.selfreading.description"),
          link: "/selfread-add",
          icon: "gc-icon-service-safety-1-col",
        },
        {
          title: t("dashboard.tab2.service.createfile.title"),
          description: t("dashboard.tab2.service.createfile.description"),
          link: "/view-cases",
          icon: "gc-icon-functional-tools-1-col",
        },
        {
          title: "Richiedi informazioni",
          description: "",
          link: "/richiedi-informazioni",
          icon: "gc-icon-functional-tools-1-col",
        },
      ],
    },
  ];

  const bankDomiciliation = [
    { icon: "gc-icon-service-domiciliazione-bancaria-2-col" },
    { icon: "gc-icon-functional-agreement-2-col" },
  ];
  const appIcon= [
    { icon: "gc-icon-service-app-2-col" }
  ];
  const communalTutelaPerdite = [{ icon: "gc-icon-service-water-2-col" }];

  const PrivateDashboard = () => (
    <div className="dashboard-sections private">
      {notifications && <UserNotifications notifications={notifications} />}
      <DashboardHeader
        user={user}
        contracts={contracts}
        bill={bill}
        usage={usage}
        userRole={userProfile.role}
        userProfile={userProfile}
        metre={metre}
      />
      <DashboardSummary />
      {/*<DashboardTips tips={[]} c/>*/}
      {!activeContractDomiciliation ? 
        <DashboardCommonSection
          title={t("dashboard.private.bank-domiciliation.title")}
          description={t("dashboard.private.bank-domiciliation.description")}
          link={"/domiciliazione-bancaria"}
          icon={bankDomiciliation[0].icon}
          ctaSrOnly={t("dashboard.private.ctaAttiva")}
          btnTitle={t("common.active")}
        />
        : <DashboardCommonSection
            title={t("dashboard.appBanner.title")}
            description={t("dashboard.appBanner.description")}
            link={`${Configuration.get("REACT_APP_GCAP_PUBLIC_HOST")}/${i18n.language === "en-EN" ? "en" : "it"}/my-cap`}
            icon={appIcon[0].icon}
            ctaSrOnly={t("dashboard.private.ctaScopri")}
            btnTitle={t("dashboard.appBanner.cta")}
            externalLink={true}
        />
      }
      <DashboardQuickServices services={quickServices} />
      <DashboardYourServices services={yourServices} />
    </div>
  );
  const CompanyDashboard = () => (
    <div className="dashboard-sections company">
      {notifications && <UserNotifications notifications={notifications} />}
      <DashboardHeader
        user={user}
        contracts={contracts}
        bill={bill}
        usage={usage}
        userRole={userProfile.role}
        userProfile={userProfile}
        metre={metre}
      />
      <DashboardSummary />
      {/*<DashboardDetails contracts={contracts} bill={bill} />*/}
      {/*<DashboardTips tips={[]} c/>*/}
      {!activeContractDomiciliation ?
        <DashboardCommonSection
          title={t("dashboard.private.bank-domiciliation.title")}
          description={t("dashboard.private.bank-domiciliation.description")}
          link={"/domiciliazione-bancaria"}
          icon={bankDomiciliation[0].icon}
          ctaSrOnly={t("dashboard.private.ctaAttiva")}
          btnTitle={t("common.active")}
        /> 
        : <DashboardCommonSection
          title={t("dashboard.appBanner.title")}
          description={t("dashboard.appBanner.description")}
          link={`${Configuration.get("REACT_APP_GCAP_PUBLIC_HOST")}/${i18n.language === "en-EN" ? "en" : "it"}/my-cap`}
          icon={appIcon[0].icon}
          ctaSrOnly={t("dashboard.private.ctaScopri")}
          btnTitle={t("dashboard.appBanner.cta")}
          externalLink={true}
      />
    }
      <DashboardQuickServices services={quickServices} />
      <DashboardYourServices services={yourServices} />
    </div>
  );
  const CondominiumAdminDashboard = () => (
    <div className="dashboard-sections condominium-admin">
      {notifications && <UserNotifications notifications={notifications} />}
      <DashboardHeader
        user={user}
        contracts={contracts}
        bill={bill}
        usage={usage}
        userRole={userProfile.role}
        userProfile={userProfile}
        metre={metre}
      />
      <DashboardAdminHeader />
      <DashboardNewContract
        title={t("dashboard.admin.bank-domiciliation.title")}
        description={t("dashboard.admin.bank-domiciliation.description")}
        ctaSrOnly={t("dashboard.admin.bank-association.request.cta")}
        link={"/contracts/add"}
        icon={bankDomiciliation[1].icon}
        btnTitle={t("common.combine")}
      />
      <DashboardQuickServices services={quickServicesAdmin} />
      <DashboardYourServices services={yourServicesAdmin} />
    </div>
  );
  const ComOperatorDashboard = () => {
    const [bankDomiciliaryIcon] = communalTutelaPerdite;
    return (
      <div className="dashboard-sections communal communal-operator">
        {notifications && <UserNotifications notifications={notifications} />}
        <DashboardHeader
          user={user}
          contracts={contracts}
          bill={bill}
          usage={contracts.usage}
          userRole={userProfile.role}
          userProfile={userProfile}
          metre={metre}
        />
        <DashboardSummary />
        {/*<DashboardDetails contracts={contracts} bill={bill} />*/}
        {/*<DashboardDetails contracts={contracts} bill={bill} />*/}
        {/*<DashboardTips tips={[]} c/>*/}
        <DashboardCommonSection
          title={t("dashboard.communal_operator.tutela_perdite_title")}
          description={t("dashboard.communal_operator.tutela_perdite_content")}
          link={"/tutela-perdite"}
          ctaSrOnly={t("dashboard.communal_operator.tutela_perdite.CtaAttiva")}
          icon={bankDomiciliaryIcon.icon}
          btnTitle={t(
            "dashboard.communal_operator.tutela_perdite_btn"
          )}
        />
        {/*<DashboardQuickServices services={quickServiceCommunal} />*/}
        <DashboardYourServices services={yourServicesCommunal} />
      </div>
    );
  };
  const ManagerDashboard = () => (
    <div className="dashboard-sections manager">
      {notifications && <UserNotifications notifications={notifications} />}
      <DashboardManagerHeader changeImage={() => setPopup(true)} />
    </div>
  );
  const MunicipalOperator = () => (
    <div className="dashboard-sections manager municipal">
      {notifications && <UserNotifications notifications={notifications} />}
      <DashboardManagerHeader changeImage={() => setPopup(true)} />
      <ListCasePage />
      <br />
    </div>
  );
  const getDashboardForUser = () => {
    const dashboards = {
      [UserRoleEnum.PRIVATE]: <PrivateDashboard />,
      [UserRoleEnum.COMPANY]: <CompanyDashboard />,
      [UserRoleEnum.CONDOMINIUM_ADMIN]: <CondominiumAdminDashboard />,
      [UserRoleEnum.MANAGER]: <ManagerDashboard />,
      [UserRoleEnum.OPERATOR]: <ManagerDashboard />,
      [UserRoleEnum.MUNICIPAL_OPERATOR]: <MunicipalOperator />,
      [UserRoleEnum.MUNICIPAL_USER]: <ComOperatorDashboard />,
      [UserRoleEnum.PARTNER]: <Redirect to={'/area-soci'} />,
    };
    return dashboards[userProfile.role];
  };
  const getImpersonationSearchForOperator = () => {
    const dashboards = {
      [UserRoleEnum.OPERATOR]: <DashboardImpersonationSearch />,
      [UserRoleEnum.MANAGER]: <DashboardImpersonationSearch />,
    };
    return dashboards[userProfile.role];
  };
  if (toBeReloadContract) {
    dispatch(reloadContracts());
  }
  
  return user && userProfile ? (
    <div className="Dashboard dashboard-ready" data-testid="Dashboard">
      {(!contracts || !contracts.length) &&
       (userProfile.role === UserRoleEnum.PRIVATE || 
        userProfile.role === UserRoleEnum.COMPANY || 
        userProfile.role === UserRoleEnum.CONDOMINIUM_ADMIN) &&
        (
          <Modal
            show={showPopup}
            onClose={() => setShowPopup(false)}
            description={t("dashboard.associateContract.modal.title")}
            type={"link"}
            styleType={"primary"}
            to={"/contracts/add"}
            linkTitle={t("dashboard.associateContract.cta.to")}
            descriptionSection2={t("dashboard.associateContract.modal.subtitle")}
            typeSection2={"link"}
            styleTypeSection2={"primary"}
            toSection2={"/voltura"}
            linkTitleSection2={t("dashboard.transfer.cta.to")}
          />
        )
      }
      <Modal
        noIcon={true}
        isChangeImageModal={true}
        onClose={() => setPopup(false)}
        show={changeImagePopup}
        children={
          <div>
            <ImageUploader isFromModal={true} setPopup={setPopup} confirmUpload={true} t={t} />
          </div>
        }
      />
      {getDashboardForUser()}
      {getImpersonationSearchForOperator()}
    </div>
  ) : null;
};

Dashboard.propTypes = {};


export default Dashboard;
